const loaderSrc = 'https://dyv6f9ner1ir9.cloudfront.net/assets/js/nloader.js';
const loaderPath = 'dyv6f9ner1ir9.cloudfront.net/assets/js/nloader.js';
const loaderKey = 'propelOutgrowEmbedLoader';
const initializedAttribute = 'data-outgrow-initialized';
const embedUrls = {
	'640b711d6c3f8118ffbce635':
		'https://cmp.outgrow.us/640b711d6c3f8118ffbce635?vHeight=1',
	'64cbc478e0681a6bdf1dd767':
		'https://cmp.outgrow.us/64cbc478e0681a6bdf1dd767?vHeight=1',
	'655cf85330215225ebcfa437':
		'https://cmp.outgrow.us/655cf85330215225ebcfa437?vHeight=1',
};
const allowedEmbedIds = Object.keys(embedUrls);

const getEmbeds = () =>
	Array.from(
		document.querySelectorAll('.block-outgrow-embed > .op-interactive[id]')
	).filter(
		(embed) =>
			allowedEmbedIds.includes(embed.id) &&
			!embed.hasAttribute(initializedAttribute)
	);

const loadOutgrow = () => {
	if (typeof window.initIframe === 'function') {
		return Promise.resolve();
	}

	if (window[loaderKey]) {
		return window[loaderKey];
	}

	window[loaderKey] = new Promise((resolve, reject) => {
		const existingScript = Array.from(document.scripts).find((script) =>
			script.src.includes(loaderPath)
		);

		if (existingScript) {
			existingScript.addEventListener('load', resolve, { once: true });
			existingScript.addEventListener('error', reject, { once: true });
			return;
		}

		const script = document.createElement('script');

		script.async = true;
		script.defer = true;
		script.src = loaderSrc;
		script.addEventListener('load', resolve, { once: true });
		script.addEventListener('error', reject, { once: true });

		document.head.appendChild(script);
	});

	return window[loaderKey];
};

const initEmbeds = () => {
	const embeds = getEmbeds();

	if (embeds.length === 0) {
		return;
	}

	loadOutgrow()
		.then(() => {
			if (typeof window.initIframe !== 'function') {
				return;
			}

			embeds.forEach((embed) => {
				embed.dataset.url = embedUrls[embed.id];
				embed.dataset.width = '100%';

				window.initIframe(embed.id);
				embed.setAttribute(initializedAttribute, 'true');
			});
		})
		.catch(() => {
			window[loaderKey] = null;
		});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initEmbeds, { once: true });
} else {
	initEmbeds();
}
